import { Component, OnInit, ViewChild } from '@angular/core';
import { IonSlides } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { FormServices } from 'src/app/services/form-services.service';
import { HttpService } from 'src/app/services/http.service';
import { ParamServicesService } from 'src/app/services/param-services.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sliders-of-home-section',
  templateUrl: './sliders-of-home-section.component.html',
  styleUrls: ['./sliders-of-home-section.component.scss'],
})
export class SlidersOfHomeSectionComponent implements OnInit {
  @ViewChild('slider', { static: true }) slider: IonSlides;
  domainId = environment.domainId;
  fieldForms: any;
  savedForm: any;
  id: any;
  isUploading = false;
  slides = [];
  typeSlider = '';
  typeSliderPrimary = '';
  typeSliderSecondary = '';
  constructor(
    private formSv: FormServices,
    private httpSv: HttpService,
    private uiSv: UiServices,
    private paramSv: ParamServicesService,
    private translateSv: TranslateService
  ) {}

  async ngOnInit() {
    try {
      if (this.paramSv.typeSliderPrimary || this.paramSv.typeSliderSecondary) {
        this.typeSliderPrimary = this.paramSv.typeSliderPrimary;
        this.typeSliderSecondary = this.paramSv.typeSliderSecondary;
      } else {
        const susParam = this.paramSv.emitImagesObs.subscribe((item: any) => {
          if (item === 'finish') {
            susParam.unsubscribe();
          }
          if (
            item.name === 'sliderPrincipal' ||
            item.name === 'sliderSecundario'
          ) {
            item.name === 'sliderPrincipal'
              ? (this.typeSliderPrimary = this.paramSv.typeSliderPrimary)
              : (this.typeSliderSecondary = this.paramSv.typeSliderSecondary);
          }
        });
      }
      this.slider.lockSwipes(true);
      const res = await this.formSv.getForm('carrousel', this.domainId);
      const slides: any = await this.httpSv.itemIndex('slider');
      this.slides = slides.data;
      this.fieldForms = res;
    } catch (err) {
      console.error(err);
    }
  }

  async sendInfo(ev: FormData, image) {
    try {
      if (ev) {
        await this.uiSv.showLoading();
        this.id && ev?.set('bannerId', String(this.id));
        if (image.id) {
          image.id && ev.set('id', String(image.id));
        }
        this.isUploading = true;
        const res: any = await this.httpSv.itemAction(
          ev,
          'slider',
          image.id ? 'update' : 'store'
        );
        if (res.status) {
          image.id = res.data.id;
        }
        this.isUploading = false;
        await this.uiSv.loading.dismiss();
        const translate = this.translateSv.instant(
          'CARROUSEL_GUARDADO_EXITOSAMENTE'
        );
        await this.uiSv.showToast(translate);
      }
    } catch (err) {
      console.error(err);
      await this.uiSv.loading.dismiss();
    }
  }

  setSlide(ev) {
    const id = ev.detail.value;
    this.id = id;
    this.savedForm = this.slides.find((item) => item.id === id);
    this.typeSlider = this.savedForm.name;
    this.savedForm.images.forEach((img) => {
      !img.media && img.file && (img.media = [{ file: img.file }]);
      img.smallFiles = [
        {
          file: img.smallFile,
        },
      ];
    });
  }

  slideTo(direction: string) {
    this.slider.lockSwipes(false);
    direction == 'next' ? this.slider.slideNext() : this.slider.slidePrev();
    this.slider.lockSwipes(true);
  }

  async createBanner() {
    if (!this.savedForm) {
      this.savedForm = {};
      this.savedForm.images = [];
    }
    if (this.savedForm.images.length < 5) {
      this.savedForm.images.unshift({});
      this.slider.lockSwipes(false);
      await this.slider.slideTo(0, 500);
      this.slider.lockSwipes(true);
    } else {
      const tr = this.translateSv.instant('MAXIMO_DE_5_IMAGENES_ALCANZADO');
      return await this.uiSv.presentAlert(tr);
    }
  }

  async deleteImg(image, index) {
    try {
      const id = image?.id;
      if (id) {
        const tr = this.translateSv.instant(
          'ESTAS_SEGURO_DE_ELIMINAR_LA_IMAGEN'
        );
        const { role } = await this.uiSv.presentAlert(tr);
        if (role === 'accept') {
          const obj = { id };
          await this.uiSv.showLoading();
          await this.httpSv.itemAction(obj, 'slider', 'destroy');
          await this.uiSv.loading.dismiss();
          this.savedForm?.images.splice(index, 1);
        }
      } else {
        this.savedForm?.images.splice(index, 1);
      }
    } catch (err) {
      console.error(err);
    }
  }
}
